import Vue from "vue";
import SharedGallerySlider from "./SharedGallerySlider.vue";

export function load() {
  const selector = "GenericGallerySlider-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SharedGallerySlider, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
